import { defineComponent as _defineComponent } from 'vue'
import {convertToHumanAmount, convertToHumanNumber, formatPrice, ITrades, timeAgo, TransactionsDTO,} from "@/shared";
import {onMounted, ref} from "vue";
import TableResponsive from "@/components/common/TableResponsive.vue";
import AccountAddress from "@/components/common/AccountAddress.vue";
import AmountEmoji from "@/components/common/AmountEmoji.vue";
import {useWalletStore} from "@/pinia";

// props
interface IProps {
	mint: string;
	decimals: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenTradeHistory',
  props: {
    mint: null,
    decimals: null
  },
  setup(__props: any) {

const props = __props as {
	mint: string;
	decimals: number;
};



const traderHistory = ref<ITrades>([]);

// store
const walletStore = useWalletStore();

// methods
function mounted() {
	getHistory(props.mint);
}

async function getHistory(mint: string): Promise<void> {
	const params = new URLSearchParams();
	params.set("from", `${Math.floor(Date.now()/1_000) - (604800 * 12)}`)

	const primitive = await (
		await fetch(
			`https://data.fluxbeam.xyz/tokens/${mint}/traders/${walletStore.address}?${params.toString()}`
		)
	).json();

	traderHistory.value = TransactionsDTO(primitive, mint, props.decimals);
}

function getTimeOfTransanction(timestamp: number): string {
	return timeAgo(timestamp * 1000)
}


// setup
onMounted(mounted);

return { __sfc: true,props, traderHistory, walletStore, mounted, getHistory, getTimeOfTransanction, convertToHumanAmount, convertToHumanNumber, formatPrice, TableResponsive, AccountAddress, AmountEmoji }
}

})